module.exports = __webpack_public_path__ + "media/blog/twitter-e78ee06c.png";